import * as queries from "./queries";
import { client } from "../providers/Apollo";

export const createInsurance = async (input, dispatch) => {
  dispatch({
    type: "createInsuranceLoading",
    loading: true,
  });
  try {
    const res = await client.mutate({
      mutation: queries.CREATE_INSURANCE,
      variables: {
        input,
      },
    });
    dispatch({
      type: "createInsuranceSuccess",
      loading: false,
      payload: res.data.createInsurancePolicy,
      errors: [],
    });
  } catch (error) {
    dispatch({
      type: "createInsuranceError",
      loading: false,
      errors: [error],
    });
  }
};

export const getSports = async (data, dispatch) => {
  dispatch({
    type: "getSportsLoading",
    loading: true,
  });
  try {
    const res = await client.query({
      query: queries.GET_SPORTS,
    });
    dispatch({
      type: "getSportsSuccess",
      loading: false,
      payload: res.data.sports,
      errors: [],
    });
  } catch (error) {
    dispatch({
      type: "getSportsError",
      loading: false,
      errors: [error],
    });
  }
};

export const updateInsurance = async (data, dispatch) => {
  if (Object.keys(data).length) {
    dispatch({
      type: "updateInsuranceLoading",
      loading: true,
    });
    try {
      const res = await client.mutate({
        mutation: queries.UPDATE_INSURANCE,
        variables: {
          input: {
            ...data,
          },
        },
      });
      dispatch({
        type: "updateInsuranceSuccess",
        loading: false,
        payload: res.data.updateInsurancePolicy,
        errors: [],
      });
    } catch (error) {
      dispatch({
        type: "updateInsuranceError",
        loading: false,
        errors: [error],
      });
    }
  }
};

export const signIn = async (data, dispatch) => {
  dispatch({
    type: "signInLoading",
    loading: true,
  });
  try {
    const res = await client.mutate({
      mutation: queries.SIGNIN,
      variables: {
        data,
      },
    });
    localStorage.setItem("token", res.data.signin.token);
    dispatch({
      type: "signInSuccess",
      loading: false,
      payload: res.data.signup,
      errors: [],
    });
    window.open("/account", "_self");
  } catch (error) {
    dispatch({
      type: "signInError",
      loading: false,
      errors: [error],
    });
  }
};

export const register = async (data, dispatch) => {
  dispatch({
    type: "signUpLoading",
    loading: true,
  });
  try {
    const res = await client.mutate({
      mutation: queries.SIGNUP,
      variables: {
        data,
      },
    });
    localStorage.setItem("token", res.data.signup.token);
    dispatch({
      type: "signUpSuccess",
      loading: false,
      payload: res.data.signup,
      errors: [],
    });
    window.open("/account", "_self");
  } catch (error) {
    dispatch({
      type: "signUpError",
      loading: false,
      errors: [error],
    });
  }
};

export const signUp = async (data, dispatch, payInsuranceCallback) => {
  dispatch({
    type: "signUpLoading",
    loading: true,
  });
  try {
    const res = await client.mutate({
      mutation: queries.SIGNUP,
      variables: {
        data,
      },
    });
    localStorage.setItem("token", res.data.signup.token);
    dispatch({
      type: "signUpSuccess",
      loading: false,
      payload: res.data.signup,
      errors: [],
    });
  } catch (error) {
    dispatch({
      type: "signUpError",
      loading: false,
      errors: [error],
    });
  } finally {
    payInsuranceCallback(); // this is call back for pay insurance action
  }
};

export const payInsurance = async (input, dispatch, signupTriggerCallback) => {
  dispatch({
    type: "payInsuranceLoading",
    loading: true,
  });
  try {
    const res = await client.mutate({
      mutation: queries.PAY_INSURANCE,
      variables: {
        input,
      },
    });
    dispatch({
      type: "payInsuranceSuccess",
      loading: false,
      payload: res.data.payInsurance,
      errors: [],
    });
    window !== "undefined" &&
      window.open(res.data.payInsurance.formUrl, "_self");
  } catch (error) {
    dispatch({
      type: "payInsuranceError",
      loading: false,
      errors: [error],
    });
  } finally {
    signupTriggerCallback();
  }
};

export const getInsurance = async (transactionId, dispatch) => {
  dispatch({ type: "loading", loading: true });
  try {
    const res = await client.mutate({
      mutation: queries.GET_ORDER_INFO,
      variables: {
        input: {
          orderId: transactionId,
        },
      },
    });

    const {
      updateOrderInfo: { insurance },
    } = res.data;

    window.dataLayer.push({
      event: "eec.purchase",
      ecommerce: {
        purchase: {
          actionField: {
            id: transactionId,
            revenue: insurance.totalPrice.toFixed(2),
          },
          products: insurance.pickedSports.map((x) => ({
            id: x.key,
            name: x.key,
            category: x.riskType,
            price: (insurance.totalPrice / insurance.insurers.length).toFixed(
              2
            ),
            quantity: insurance.insurers.length,
          })),
        },
      },

      // transactionId,
      // transactionTotal: insurance.totalPrice,
      // transactionProducts: insurance.pickedSports.map(x => ({
      //   sku: x.key,
      //   name: x.key,
      //   category: x.riskType,
      //   price: insurance.totalPrice/insurance.insurers.length,
      //   quantity: insurance.insurers.length,
      // })),
      // event: 'transactionComplete',
      // transaction: 'true',
    });
    // window.dataLayer.push({
    //   transactionId,
    //   transactionTotal: insurance.totalPrice,
    //   transactionProducts: insurance.pickedSports.map(x => ({
    //     sku: x.key,
    //     name: x.key,
    //     category: x.riskType,
    //     price: insurance.totalPrice/insurance.insurers.length,
    //     quantity: insurance.insurers.length,
    //   })),
    //   // event: 'transactionComplete',
    //   // transaction: 'true',
    // })
    dispatch({ type: "loading", loading: false });
  } catch (error) {
    console.error(error);
    dispatch({ type: "loading", loading: false });
  }
};

export const getInsurancePDF = async (orderId) => {
  try {
    const res = await client.query({
      query: queries.GET_PDF_INSURANCE,
      variables: {
        input: {
          orderId,
        },
      },
    });

    window && window.open(res.data.getInsurancePolicyPDFLink, "_self");
  } catch (error) {
    console.error(error);
  }
};

export const getInsurances = async () => {
  try {
    const res = await client.query({
      query: queries.GET_INSURANCES,
    });
    return res.data.insurances;
  } catch (error) {
    console.error(error);
  }
};

export const resetPassword = async (data, dispatch) => {
  try {
    const res = await client.mutate({
      mutation: queries.RESET_PASSWORD,
      variables: {
        data,
      },
    });
    dispatch({
      type: "resetPassword",
      loading: true,
      payload: res.data.resetPassword.status,
    });
  } catch (error) {
    dispatch({
      type: "resetPassword",
      errors: [error],
    });
  }
};
